<template>
<span>
	<a class="ui-btn" v-show="show" @click="onCodeClick">获取验证码</a>
	<span class="ui-btn ui-btn-disable" v-show="!show">{{codeNum + '秒后重试'}}</span>
	<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
</span>
</template>

<script>
var tid = 0
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
export default {
	props: {
		email: String,
		type: Number,
		verifyCode: String,
		uuid: String
	},
	data () {
		return {
			show: true,
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			code: '',
			codeNum: 0,
			codeDisable: false,
			patrn: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
			sec: 1500
		}
	},
	components: {
		'tips': Tips,
		'tips-auto': TipsAuto
	},
	methods: {
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		onCodeClick () {
			if (this.email === '') {
				this.autoTips('邮箱地址不能为空')
				return false
			} else if (!(this.patrn.test(this.email))) {
				this.autoTips('邮箱地址格式不正确')
				return false
			} else if (this.verifyCode === '') {
				this.autoTips('图形验证码不能为空')
				return false
			}
			this.show = false
			this.$http.post('/cldEdi/business/vCode/get', {
				type: this.type,
				data: this.email,
				uuid: this.uuid,
				verifyCode: this.verifyCode
			}).then((response) => {
				let data = response.body
				if (!data.result) {
					this.loading = false
					this.autoTips(data.message || '发送失败')
					return Promise.reject()
				}
				this.countDown()
			}).catch(() => {
				clearInterval(tid)
				this.show = true
				this.codeNum = 0
			})
		},
		countDown () {
			if (this.codeNum > 0) return
			var self = this
			self.codeNum = 60
			self.codeDisable = true
			tid = setInterval(() => {
				if (--self.codeNum === 0) {
					this.show = true
					clearInterval(tid)
				}
			}, 1000)
		}
	}
}
</script>



// WEBPACK FOOTER //
// EmailCode.vue?513ed678